import { useState, useEffect } from "react";
import {
  Box,
  Avatar,
  Divider,
  Popover,
  MenuItem,
  Typography,
  IconButton,
  Badge,
  Tooltip,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import PersonIcon from "@mui/icons-material/Person";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../../features/authActions/authActions";

export default function AccountPopover() {
  const [open, setOpen] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userLoginData = useSelector(
    (state) => state.userLoginReducer.userLoginData?.user
  );

  // Get notification count from Redux store
  const notificationState = useSelector((state) => state.notification);
  const notificationsData = notificationState?.notificationsData || {};
  const unreadCount = notificationsData?.unreadCount || 0;

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const handleLogout = () => {
    dispatch(logout());
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("userData");
    setTimeout(() => {
      navigate("/login");
    }, 100);
  };

  const handleNotificationClick = () => {
    navigate("/settings/notifications");
  };

  useEffect(() => { }, [userLoginData]);

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      {/* Simple Notification Icon that navigates to notifications page */}
      <Tooltip title="Notifications">
        <IconButton 
          color="black" 
          onClick={handleNotificationClick}
          sx={{
            position: 'relative',
          }}
        >
          <Badge 
            badgeContent={unreadCount} 
            color="error" 
            max={99}
            sx={{
              '& .MuiBadge-badge': {
                backgroundColor: '#f44336',
                color: 'white',
                fontSize: '0.65rem',
                minWidth: 16,
                height: 16,
                padding: '0 4px',
              },
            }}
          >
            <NotificationsNoneIcon />
          </Badge>
        </IconButton>
      </Tooltip>

      {/* Profile Avatar */}
      <IconButton
        onClick={handleOpen}
        sx={{
          width: 40,
          height: 40,
          background: (theme) => alpha(theme.palette.grey[500], 0.08),
          ...(open && {
            background: (theme) =>
              `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
          }),
        }}
      >
        <Avatar
          src={userLoginData?.profileImage}
          alt={userLoginData?.name}
          sx={{
            width: 36,
            height: 36,
            border: (theme) => `solid 2px ${theme.palette.background.default}`,
          }}
        />
      </IconButton>

      {/* Popover */}
      <Popover
        open={!!open}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            p: 0,
            mt: 1,
            ml: 0.75,
            width: 230,
          },
        }}
      >
        <Link
          to="/Settings"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <Box sx={{ my: 1.5, px: 2 }} style={{ textTransform: "capitalize" }}>
            <Typography variant="subtitle2" noWrap>
              {userLoginData?.name}
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary" }} noWrap>
              {userLoginData?.email}
            </Typography>
          </Box>
          <Divider sx={{ borderStyle: "dashed" }} />
          <MenuItem
            disableRipple
            disableTouchRipple
            sx={{ typography: "body2", py: 1 }}
          >
            <PersonIcon />
            Profile
          </MenuItem>
        </Link>
        <Divider sx={{ borderStyle: "dashed" }} />
        <MenuItem
          disableRipple
          disableTouchRipple
          onClick={handleLogout}
          sx={{ typography: "body2", color: "error.main", py: 1.5 }}
        >
          Logout
        </MenuItem>
      </Popover>
    </Box>
  );
}